<template>
<div>
  <div class="myorder">
    <div class="app-top-nav">
      <router-link :to="{ name: 'myorder', query: { status: 0 }}" :class="[status==0?'cur':'']" replace>待支付</router-link>
      <router-link :to="{ name: 'myorder', query: { status: 1 }}" :class="[status==1?'cur':'']" replace>服务中</router-link>
      <router-link :to="{ name: 'myorder', query: { status: 2 }}" :class="[status==2?'cur':'']" replace>待取件</router-link>
      <router-link :to="{ name: 'myorder', query: { status: 3 }}" :class="[status==3?'cur':'']" replace>待评价</router-link>
      <router-link :to="{ name: 'myorder', query: { status: 4 }}" :class="[status==4?'cur':'']" replace>已完成</router-link>
      <router-link :to="{ name: 'myorder', query: { status: -1 }}" :class="[status==-1?'cur':'']" replace>全部</router-link>
    </div>
    <div v-if="list.length > 0" class="list">
      <router-link v-for="(v,k) in list" v-bind:key="k" :to="{ name: 'orderinfo', query: { oid: v.oid }}" class="item">
        <div class="sitem topline">
          <span class="tit">订单号：{{v.oid}}</span>
          <span v-if="v.status==0" class="status">待支付</span>
          <span v-if="v.status==1" class="status">服务中</span>
          <span v-if="v.status==2" class="status">待取件</span>
          <span v-if="v.status==3" class="status">待评价</span>
          <span v-if="v.status==4" class="status">已完成</span>
        </div>
        <div class="sitem topline">
          <div class="ovh">
            <div class="name storename fl">店名：{{v.store}}</div>
            <!-- <div class="name fr">店员：衣印</div> -->
          </div>

          <p class="time">送洗时间：{{v.created_at}}</p>
        </div>

        <div v-for="(nv,nk) in v.noteArr" v-bind:key="nk" class="sitem sitem2 topline">
            <p v-for="(item,key) in cloth" v-bind:key="key" v-if="nv[key]">
              {{item}}：<span>{{nv[key]}}</span>
            </p>
            <!-- <p v-for="(item,key) in cloth2" v-bind:key="key" v-if="nv[key]">
              {{item}}：<span>{{nv[key]}}</span>
            </p> -->
        </div>
        <div class="total sitem  topline bottomline">
          <p>衣物件数：<span>{{v.clothNum}}件</span></p>
          <div v-if="v.status==0" class="ovh">
            <p class="fl">支付状态：<span>未付款</span></p>
            <p class="fr">合计金额：<span class="num">{{v.price}}</span>元</p>
          </div>
          <div v-else class="ovh">
            <p>付款方式：<span v-if="v.pay_type == 0">余额支付</span><span v-if="v.pay_type == 1">单位余额支付</span></p>
            <p class="fl">合计金额：<span><span class="snum">{{v.price}}</span>元</span></p>
            <p class="fr">支付金额：￥<span v-if="v.pay_type==0" class="num">{{v.money.toFixed(2)}}</span><span v-if="v.pay_type==1" class="num">{{v.money_company.toFixed(2)}}</span></p>
          </div>
        </div>

        <div v-if="v.status==0 || v.status==2 || v.status==3 || v.status==4" class="operation sitem bottomline ovh">
          <span v-if="v.status==0" class="btn">支付</span>
          <span v-if="v.status==2" class="btn">确认收货</span>
          <span v-if="v.status==3" class="btn">评价</span>
          <span v-if="v.status==4" class="btn">查看评价</span>
        </div>
      </router-link>
    </div>
    <div v-else class="nodata">暂无数据</div>

    <div v-infinite-scroll="loadMore" infinite-scroll-disabled="busy" infinite-scroll-distance="10"></div>
  </div>
  <div class="weui-loadmore" v-if="load">
      <i class="weui-loading"></i>
      <span class="weui-loadmore__tips">正在加载</span>
  </div>
</div>
</template>

<script>
import infiniteScroll from '@/basic/infiniteScroll'
export default {
  directives: {infiniteScroll},
  data(){
    return{
      cloth:{
        "clothesno": "衣物编号",
        "clothesname": "衣物名称",
        "clothescolor": "颜色",
        "washtype": "洗涤方式",
        "clothesje": "金额",
        "clothesssje": "实收金额",
        "brand": "衣物品牌",
        "clothesstatus": "衣物状态",
        "attachment": "衣物附件",
        "note": "备注",
        "requirement": "客人要求",
        "additional": "附加要求",
        "additional_price": "附加价格"
      },
      cloth2:{
        "clothesstatus": "衣物状态",
        "attachment": "衣物附件",
        "note": "备注",
        "requirement": "客人要求",
        "additional": "附加要求",
        "additional_price": "附加价格"
      },
      list:[],
      busy: true,
      load:true,
      page:1,
      status:-1
    }
  },
  mounted(){
    var vm = this;
    vm.status = vm.$route.query.status;
    vm.getAccountOrder()
    vm.$watch("$route", function(newVal, oldVal) {
        vm.page = 1;
        vm.status = newVal.query.status;
        vm.getAccountOrder()
    })
  },
  methods: {
    getAccountOrder(flag){
      let vm = this;
      let str = 'page='+vm.page;
      if(vm.status>=0){
        str += '&status='+vm.status;
      }
      vm.ajax("account/order", "get", str, e => {
        vm.load = false;
        if(e.data.list){
          let list = e.data.list;
          list.map((v,k)=>{
            v.clothNum = 0;
            if(v.note){
              try {
                v.noteArr = JSON.parse(v.note);
                v.clothNum = v.noteArr.length;
              } catch (error) {

              }
            }
          })
          if(flag){
            vm.list =  vm.list.concat(list)
            if(e.data.count == vm.page){
                vm.busy = true;
            }else{
                vm.busy = false;
            }
          }else{
            // console.log('222')
            vm.list =  list;
            if(vm.list.length < e.data.limit){
              vm.busy = true;
            }else{
              vm.busy = false;
            }
          }
        }else{
          if(!flag){
            vm.list =  [];
          }
          vm.busy = true;
        }
      })
    },
    loadMore() {
      let vm = this;
      vm.busy = true;
      vm.load = true;
      setTimeout(() => {
          vm.page++;
          vm.getAccountOrder(true);
      }, 1000);
    }
  }
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/myorder.vue